import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { notificationsApi } from '../../api/notifications';

export function NotificationBell() {
  const navigate = useNavigate();
  const location = useLocation();
  // ActiveSessionScreen renders a taller fixed bottom bar (finish/cancel actions) that
  // sits above the regular bottom nav, so the bell needs extra clearance there or its
  // bottom edge gets covered by that bar.
  const extraOffset = location.pathname.startsWith('/shopping/active') ? 4.5 : 0;

  const { data } = useQuery({
    queryKey: ['notifications-count'],
    queryFn: notificationsApi.unreadCount,
    staleTime: 60_000,
    refetchInterval: 120_000,
  });

  const count = data?.count ?? 0;

  return (
    <button
      onClick={() => navigate('/notifications')}
      aria-label="Notificações"
      className="fixed z-50 bg-white shadow-lg border border-gray-200 rounded-full w-12 h-12 flex items-center justify-center touch-manipulation hover:bg-gray-50 transition-colors"
      style={{
        bottom: `calc(4.5rem + env(safe-area-inset-bottom) + ${extraOffset}rem)`,
        left: '1rem',
      }}
    >
      <div className="relative">
        <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} className="text-gray-600">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
        {count > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-0.5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center leading-none">
            {count > 99 ? '99+' : count}
          </span>
        )}
      </div>
    </button>
  );
}
